export default {
  contactHeroTitle: "Lépjen kapcsolatba velünk",
  contactHeroSubtitle: "Itt vagyunk, hogy segítsünk navigálni a gyógyszeripari fejlesztés összetett világában. Legyen szó API gyártásról, formuláció fejlesztésről vagy szabályozási támogatásról, csapatunk készen áll segíteni.",
  contactGetInTouchTitle: "Lépjen kapcsolatba",
  contactOurAddress: "Címünk",
  contactMainAddress: "67, Bazullah Road,<br />Partha Sarathy Puram,<br />T Nagar, Chennai – 600017<br />Tamil Nadu, India",
  contactOtherAddresses: "További címek",
  contactAddressBangalore: "Phoenix Mall of Asia – 2. torony,<br />6. szint, 602. egység, Yelahanka Hobli,<br />Byatarayanapura, Bangalore – 560092,<br />Karnataka, India",
  contactAddressMumbai: "409, Bezzola Complex,<br />Sion Trombay Road,<br />Chembur, Mumbai - 400 071<br />Maharashtra, India.",
  contactAddressSwitzerland: "Bahnhof-Park 4,<br />Baar 6340,<br />Svájc",
  contactEmail: "E-mail",
  contactFormTitle: "Küldjön nekünk üzenetet",
  contactFormNameLabel: "Teljes név *",
  contactFormNamePlaceholder: "Adja meg teljes nevét",
  contactFormEmailLabel: "E-mail cím *",
  contactFormEmailPlaceholder: "Adja meg e-mail címét",
  contactFormPhoneLabel: "Telefonszám",
  contactFormPhonePlaceholder: "Adja meg telefonszámát",
  contactFormCompanyLabel: "Vállalat",
  contactFormCompanyPlaceholder: "Adja meg vállalata nevét",
  contactFormMessageLabel: "Üzenet *",
  contactFormMessagePlaceholder: "Meséljen nekünk projektjéről vagy kérdéséről...",
  contactFormCharacters: "karakter",
  contactFormSubmitButton: "Lépjen kapcsolatba",
  contactFormSubmitting: "Küldés...",
  contactFormRecaptchaRequired: "Kérjük, töltse ki a reCAPTCHA-t",
  contactFormSuccess: "Köszönjük! Üzenete sikeresen elküldve. 24 órán belül válaszolunk.",
  contactFormError: "Sajnáljuk, hiba történt az üzenet küldése során. Kérjük, próbálja újra vagy lépjen közvetlenül kapcsolatba velünk.",
};

